import { FormlyFieldConfig } from '@ngx-formly/core';

export function findFieldsByKey(field: FormlyFieldConfig, key: string): FormlyFieldConfig[] {
  let root = field;
  while (root.parent) {
    root = root.parent;
  }

  const matches: FormlyFieldConfig[] = [];
  const walk = (config: FormlyFieldConfig, path: string) => {
    let currentPath = path;
    if (hasKey(config)) {
      currentPath = path ? `${path}.${keyToString(config.key)}` : keyToString(config.key);
    }
    if (currentPath === key) {
      matches.push(config);
    }
    config.fieldGroup?.forEach((child) => walk(child, currentPath));
    if (config.fieldArray) {
      walk(resolveFieldArray(config.fieldArray, config), currentPath);
    }
  };
  walk(root, '');
  return matches;
}

function hasKey(config: FormlyFieldConfig): boolean {
  return config.key !== undefined && config.key !== null && config.key !== '';
}

function resolveFieldArray(
  fieldArray: NonNullable<FormlyFieldConfig['fieldArray']>,
  parent: FormlyFieldConfig,
): FormlyFieldConfig {
  return typeof fieldArray === 'function' ? fieldArray(parent) : fieldArray;
}

function keyToString(key: FormlyFieldConfig['key']): string {
  return Array.isArray(key) ? key.join('.') : String(key);
}
